// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.callout {
  width: 300px;
  position: absolute;
  z-index: 999;
  right: 0;
  bottom: 100%;
  display: none;
  text-align: left;
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12);
  overflow: hidden;
}
.callout.callout-open {
  display: block;
}
.callout .btn-delete {
  background: #dc3545;
  color: #fff;
  border: 0;
  padding: 6px 10px 1px;
}
.callout .btn-add {
  color: #fff;
  border: 0;
  padding: 6px 10px 1px;
}
.callout .v-checkbox-wrap {
  display: flex;
}
.callout .checkbox {
  font-size: 14px;
  display: flex;
  align-items: center;
}
.callout .checkbox input + span {
  margin-right: 10px;
}
.callout .callout-title {
  font-weight: 500;
}

.callout-header {
  position: relative;
}

.callout-header {
  padding: 10px 15px;
}

.callout-body .callout-body-inner {
  padding: 10px 0;
}

.callout-body {
  min-height: 250px;
}
.callout-body .items {
  list-style: none;
  margin: 0;
  padding: 0;
}
.callout-body .callout-list-item {
  display: flex;
  align-items: center;
}
.callout-body .callout-list-item .callout-actions {
  margin-left: auto;
}
.callout-body .callout-list-form,
.callout-body .callout-list-item {
  padding: 6px 15px;
}

.callout-filter {
  padding: 6px;
  border-bottom: 1px solid #B2B5C4;
}

.callout-filter-table {
  width: 100%;
}

.callout-actions {
  float: right;
  -webkit-user-select: none;
          user-select: none;
}
.callout-actions span {
  line-height: inherit;
  display: inline-block;
}
.callout-actions .action {
  cursor: pointer;
}
.callout-actions .material-icons {
  font-size: 16px;
  line-height: 1;
  padding-left: 2px;
  padding-right: 2px;
}
.callout-actions {
  /* span {
  	color: #666;
  	//&:hover {
  	//	color: \$themeColor;
  	//}
  } */
}

/* .callout-header-actions {
	position: absolute;
	right: 0;
	top: 0;
	bottom: 0;
	padding: 6px 5px 5px 15px;
	> span {
		display: inline-block;
		vertical-align: top;
	}
} */
.callout-close {
  background: none;
  border: 0;
  padding: 1px 0 0;
  line-height: 1;
  float: right;
  cursor: pointer;
  outline: 0;
  width: 30px;
  margin-right: -10px;
}
.callout-close i {
  line-height: inherit;
}
.callout-close:hover {
  color: #dc3545;
}

.colorPicker-trigger {
  cursor: pointer;
}

.callout-edit-view {
  background: #f3f3f3;
  margin-top: 5px;
  margin-bottom: 5px;
  padding: 10px 15px;
}
.callout-edit-view input {
  border-radius: 0;
}
.callout-edit-view select,
.callout-edit-view textarea {
  width: 100%;
  margin-top: 5px;
  margin-bottom: 5px;
  border-radius: 0;
}

.callout-body-scroll {
  min-height: inherit;
  height: 250px;
  max-height: 300px;
}

.callout-body-scroll-edit-mode {
  max-height: 484px;
}

.with-border {
  position: relative;
  padding-left: 15px;
}
.with-border:before {
  content: "";
  display: block;
  height: 26px;
  width: 5px;
  position: absolute;
  left: 0;
  top: 50%;
  margin-top: -13px;
  border-radius: 0 5px 5px 0;
}

@media (max-height: 600px) {
  .callout-body-scroll {
    max-height: 200px;
  }
  .callout {
    width: 300px;
  }
}
@media (max-width: 767px) {
  .callout {
    right: 0;
  }
}
@media (max-width: 479px) {
  .callout {
    width: 100%;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 9;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/Features/Callout/index.scss","webpack://./src/assets/variables.scss"],"names":[],"mappings":"AAEA;EACC,YAAA;EACA,kBAAA;EACA,YAAA;EACA,QAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,yHAAA;EACA,gBAAA;AADD;AAEC;EACC,cAAA;AAAF;AAEC;EACC,mBCqCS;EDpCT,WAAA;EACA,SAAA;EACA,qBAAA;AAAF;AAEC;EACC,WAAA;EACA,SAAA;EACA,qBAAA;AAAF;AAGC;EACC,aAAA;AADF;AAIC;EACC,eC+Ca;ED9Cb,aAAA;EACA,mBAAA;AAFF;AAGE;EACC,kBAAA;AADH;AAKC;EACC,gBAAA;AAHF;;AAMA;EACC,kBAAA;AAHD;;AAKA;EACC,kBAAA;AAFD;;AAIA;EACC,eAAA;AADD;;AAIA;EACC,iBAAA;AADD;AAEC;EACC,gBAAA;EACA,SAAA;EACA,UAAA;AAAF;AAEC;EACC,aAAA;EACA,mBAAA;AAAF;AACE;EACC,iBAAA;AACH;AAEC;;EAEC,iBAAA;AAAF;;AAIA;EACC,YAAA;EACA,gCAAA;AADD;;AAGA;EACC,WAAA;AAAD;;AAEA;EACC,YAAA;EACA,yBAAA;UAAA,iBAAA;AACD;AACC;EACC,oBAAA;EACA,qBAAA;AACF;AACC;EACC,eAAA;AACF;AACC;EACC,eAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;AACF;AAhBA;EAoBC;;;;;KAAA;AAID;;AAIA;;;;;;;;;;GAAA;AAWA;EACC,gBAAA;EACA,SAAA;EACA,gBAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;AADD;AAEC;EACC,oBAAA;AAAF;AAGC;EACC,cClFS;ADiFX;;AAKA;EACC,eAAA;AAFD;;AAIA;EACC,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;AADD;AAEC;EACC,gBAAA;AAAF;AAEC;;EAEC,WAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AAAF;;AAIA;EACC,mBAAA;EACA,aAAA;EACA,iBAAA;AADD;;AAGA;EACC,iBAAA;AAAD;;AAIA;EACC,kBAAA;EACA,kBAAA;AADD;AAEC;EACC,WAAA;EACA,cAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,iBAAA;EACA,0BAAA;AAAF;;AAQA;EACC;IACC,iBAAA;EALA;EAOD;IACC,YAAA;EALA;AACF;AAQA;EACC;IACC,QAAA;EANA;AACF;AAQA;EACC;IACC,WAAA;IACA,eAAA;IACA,MAAA;IACA,QAAA;IACA,SAAA;IACA,OAAA;IACA,UAAA;EANA;AACF","sourcesContent":["@import './../../../assets/variables';\n\n.callout {\n\twidth: 300px;\n\tposition: absolute;\n\tz-index: 999;\n\tright: 0;\n\tbottom: 100%;\n\tdisplay: none;\n\ttext-align: left;\n\tbox-shadow: 0px 1px 5px 0px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 3px 1px -2px rgba(0,0,0,0.12);\n\toverflow: hidden;\n\t&.callout-open {\n\t\tdisplay: block;\n\t}\n\t.btn-delete {\n\t\tbackground: $danger;\n\t\tcolor: #fff;\n\t\tborder: 0;\n\t\tpadding: 6px 10px 1px;\n\t}\n\t.btn-add {\n\t\tcolor: #fff;\n\t\tborder: 0;\n\t\tpadding: 6px 10px 1px;\n\t}\n\n\t.v-checkbox-wrap {\n\t\tdisplay: flex;\n\t}\n\n\t.checkbox {\n\t\tfont-size: $baseFontSize;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tinput + span {\n\t\t\tmargin-right: 10px;\n\t\t}\n\t\n\t}\n\t.callout-title {\n\t\tfont-weight: 500;\n\t}\n}\n.callout-header {\n\tposition: relative;\n}\n.callout-header {\n\tpadding: 10px 15px;\t\n}\n.callout-body .callout-body-inner {\n\tpadding: 10px 0;\t\n}\n\n.callout-body {\n\tmin-height: 250px;\n\t.items {\n\t\tlist-style: none;\n\t\tmargin: 0;\n\t\tpadding: 0;\n\t}\n\t.callout-list-item {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\t.callout-actions {\n\t\t\tmargin-left: auto;\n\t\t}\n\t}\n\t.callout-list-form,\n\t.callout-list-item {\n\t\tpadding: 6px 15px;\n\t}\n}\n\n.callout-filter {\n\tpadding: 6px;\t\n\tborder-bottom: 1px solid $borderColor;\n}\n.callout-filter-table {\n\twidth: 100%;\n}\n.callout-actions {\n\tfloat: right;\n\tuser-select: none;\n\t\n\tspan {\n\t\tline-height: inherit;\n\t\tdisplay: inline-block;\n\t}\n\t.action {\n\t\tcursor: pointer;\n\t}\n\t.material-icons {\n\t\tfont-size: 16px;\n\t\tline-height: 1;\n\t\tpadding-left: 2px;\n\t\tpadding-right: 2px;\n\t\t.fms-sidebar & {\n\t\t\t//line-height: 35px;\n\t\t}\n\t}\n\t/* span {\n\t\tcolor: #666;\n\t\t//&:hover {\n\t\t//\tcolor: $themeColor;\n\t\t//}\n\t} */\n\n}\n/* .callout-header-actions {\n\tposition: absolute;\n\tright: 0;\n\ttop: 0;\n\tbottom: 0;\n\tpadding: 6px 5px 5px 15px;\n\t> span {\n\t\tdisplay: inline-block;\n\t\tvertical-align: top;\n\t}\n} */\n.callout-close {\n\tbackground: none;\n\tborder: 0;\n\tpadding: 1px 0 0;\n\tline-height: 1;\n\tfloat: right;\n\tcursor: pointer;\n\toutline: 0;\n\twidth: 30px;\n\tmargin-right: -10px;\n\ti {\n\t\tline-height: inherit;\n\t}\n\n\t&:hover {\n\t\tcolor: $danger\n\t}\n}\n\n.colorPicker-trigger {\n\tcursor: pointer\n}\n.callout-edit-view {\n\tbackground: #f3f3f3;\n\tmargin-top: 5px;\n\tmargin-bottom: 5px;\n\tpadding: 10px 15px;\n\tinput {\n\t\tborder-radius: 0;\n\t}\n\tselect,\n\ttextarea {\n\t\twidth: 100%;\n\t\tmargin-top: 5px;\n\t\tmargin-bottom: 5px;\n\t\tborder-radius: 0;\n\t}\n}\n\n.callout-body-scroll {\n\tmin-height: inherit;\n\theight: 250px;\n\tmax-height: 300px;\n}\n.callout-body-scroll-edit-mode {\n\tmax-height: 484px;\n}\n\n\n.with-border {\n\tposition: relative;\n\tpadding-left: 15px;\n\t&:before {\n\t\tcontent: \"\";\n\t\tdisplay: block;\n\t\theight: 26px;\n\t\twidth: 5px;\n\t\tposition: absolute;\n\t\tleft: 0;\n\t\ttop: 50%;\n\t\tmargin-top: -13px;\n\t\tborder-radius: 0 5px 5px 0;\n\n\t}\n}\n\n\n// responsive \n\n@media (max-height: 600px) {\n\t.callout-body-scroll {\n\t\tmax-height: 200px;\n\t}\n\t.callout {\n\t\twidth: 300px;\n\t}\n}\n\n@media (max-width: 767px) {\n\t.callout {\n\t\tright: 0;\n\t}\n}\n@media (max-width: 479px) {\n\t.callout {\n\t\twidth: 100%;\n\t\tposition: fixed;\n\t\ttop: 0;\n\t\tright: 0;\n\t\tbottom: 0;\n\t\tleft: 0;\n\t\tz-index: 9;\n\t}\n}","@import \"functions\";\n@import \"mixins\";\n$themeColor: #00c179;\n$input-focus-box-shadow: none;\n$input-btn-focus-box-shadow: none;\n$btn-active-box-shadow: none;\n$input-focus-border-color: inherit;\n$btn-active-box-shadow: none;\n$input-bg: #fbfeff;\n$input-border-radius: 100px;\n$input-border-radius-sm: 100px;\n$input-border-radius-lg: 100px;\n$input-border-color: #e2e9ef;\n//$input-padding-x-sm: 10px;\n@import \"bs_variables\";\n\n// Layouts\n$sidebarWidth : 320px;\n$sidebarWidthResponsive : $sidebarWidth;\n$logoSectionHeight: 50px;\n$headerNavWidth: 50px;\n$headerNavWidthExpended: 200px;\n$headerHeight: 50px;\n$footerHeight: 0;\n$mapFiltersHeight: 36px;\n$mapWidgetsHeight: 150px;\n$topGap: $headerHeight + 3px;\n\n$themeColorInverse: #fff;\n$textColor: #333;\n$body-color: #333;\n$logoColor: $themeColor; //#012D55;\n\n\n\n// Header \n\n$borderColor: #B2B5C4;\n$linkColor: #fff;\n$hoverBg: #fff;\n$hoverColor: $themeColor;\n$hoverBorderColor: transparent;\n$subMenuHoverBg: $hoverBg;\n$subMenuHoverColor: $hoverColor;\n$menuBg: #045266;\n$blue : #012D55;\n\n\n// general\n$darkGrey: #666;\n$badgeColor: #fff;\n$badgeBgColor: $darkGrey;\n$greenColor: #28a745;\n$redColor: #dc3545;\n$skyColor: $themeColor;\n$yellowColor: #ffc107;\n$bodyBg: #e0e0e0;\n$lightGrey: #d7d7d7;\n\n$dropdown-bg: #fff;\n$dropdown-border: darken($dropdown-bg, 30%);\n\n\n\n$danger : $redColor;\n$warning : $yellowColor;\n$success : $greenColor;\n\n\n// Sidebar \n$sidebarBackground: #fff;\n$sidebarzIndex: 1;\n$sidebarHeadBg: #ffffff;\n$sidebarRowBg: #fff;\n$sidebarRowHoverBg: #f7f7f7;\n$sidebarRowColor: $darkGrey;\n\n\n// typography\n$baseFontSize: 14px;\n$baseIconFontSize: 17px;\n\n\n// Footer\n\n$footerBackground: #ececec;\n$footerFontSize: $baseFontSize + 2;\n\n\n\n\n\n$baseFontFamily: Poppins, sans-serif;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
